/**
 * Modal to compare the original selection with Gemini’s draft; user may edit the draft before accepting.
 */
export function openBeautifySelectionDialog(opts: {
  original: string;
  suggested: string;
  onAccept: (editedSuggestion: string) => void;
  onDecline: () => void;
}): void {
  const dlg = document.createElement("dialog");
  dlg.className = "npp-dialog npp-dialog-search npp-dialog-beautify-selection";
  dlg.innerHTML = `
    <div class="npp-dialog-form npp-dialog-search-form">
      <h2 class="npp-dialog-title">Review Gemini suggestion</h2>
      <p class="npp-dialog-hint">Original selection (read-only)</p>
      <pre class="npp-beautify-original" data-role="orig"></pre>
      <p class="npp-dialog-hint">Suggested text — edit if needed, then Accept or Decline</p>
      <textarea class="npp-beautify-suggested" data-role="sug" spellcheck="true" rows="10"></textarea>
      <div class="npp-dialog-actions">
        <button type="button" data-action="accept">Accept</button>
        <button type="button" data-action="decline">Decline</button>
      </div>
    </div>`;
  document.body.append(dlg);
  const origEl = dlg.querySelector<HTMLElement>('[data-role="orig"]')!;
  const sug = dlg.querySelector<HTMLTextAreaElement>('[data-role="sug"]')!;
  origEl.textContent = opts.original;
  sug.value = opts.suggested;

  const close = (): void => {
    dlg.close();
    dlg.remove();
  };

  dlg.querySelector('[data-action="accept"]')!.addEventListener("click", () => {
    opts.onAccept(sug.value);
    close();
  });
  dlg.querySelector('[data-action="decline"]')!.addEventListener("click", () => {
    opts.onDecline();
    close();
  });

  dlg.addEventListener("cancel", (e) => {
    e.preventDefault();
    opts.onDecline();
    close();
  });

  dlg.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      opts.onDecline();
      close();
    }
  });

  dlg.showModal();
  sug.focus();
  sug.setSelectionRange(0, 0);
}
